export const getMenuList = (firebase, uid, setMenuList) => {
    firebase.getMenus(uid).get()
    .then(querySnapshot => {
      querySnapshot.docs.forEach(doc => {
        setMenuList(MenuList => [...MenuList, doc.id])
      })
    })
    .catch((error) => {
        console.error('Erreur lors de la récupération des menus:', error);
    });
  }